module.exports = __webpack_public_path__ + "static/img/lunbo.04519b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_2/lunbo.jpg
// module id = LB8Y
// module chunks = 0